import { IPublishSettings, IPublishMetadata } from '../publishEndpoints';

export enum PublishRenditionType {
  Preview = 'preview',
  Full = 'full',
  Source = 'source',
}

export interface IPublishAsset {
  assetId: string;
  renditionType: PublishRenditionType;
  title?: string;
}

export interface IPublishParams {
  publishSettings: IPublishSettings<any>[],
  publishMetadata: IPublishMetadata,
  assets: IPublishAsset[],
}
